<template>
  <div class="s-uploader">
    <label for="" class="s-uploader-label">
      <input type="file" @change="fileUploadChange" :accept="accept" ref="file">
    </label>
    <slot name="preview" v-if="url" :src="url" >
      <img :src="url" class="preview" v-preview="1">
    </slot>
    <em class="icon-uploader-close" @click="handlerRemove" v-if="url"></em>
    +
  </div>
</template>
<script>
export default {
  name: 'Uploader',
  props: {
    accept: {
      type: String,
      default: 'image/*'
    },
    uploadUrl: {
      type: String
    },
    initSrc:{
      type: String
    }
  },
  data() {
    return {
      url: '',
      initial: false
    }
  },
  methods: {
    fileUploadChange(event) {
      if (event.target.files && event.target.files.length === 0) {
        return
      }

      // if( /^image/.test(this.accept) ){
      let fr = new FileReader()
      fr.onload = f => (this.url = f.target.result)
      fr.readAsDataURL(event.target.files[0])
      // }

      let formData = new FormData()
      formData.append('file', event.target.files[0])
      this.$http.post(this.uploadUrl, formData).then(
        response => {
          let data = response.body
          if (data.code === 0) {
            this.$emit('change', {
              url: data.Path
            })
          } else {
            this.$emit('error', data)
            this.$refs.file.vlaue = ''
            this.url = ''
          }
        },
        response => {
          this.$emit('error', response.body)
          this.$refs.file.vlaue = ''
          this.url = ''
        }
      )
    },
    handlerRemove() {
      this.url = ''
      this.$emit('change')
    }
  },
  watch:{
    initSrc(val) {
      console.log(val)
      if(val && !this.initial){
        this.initial = true
        this.url = val
      }
    }
  }
}
</script>

<style scoped lang="less">
.s-uploader {
  width: 100px;
  height: 100px;
  font-size: 20px;
  line-height: 100px;
  text-align: center;
  border-radius: 6px;
  display: inline-block;
  color: #5d5e66;
  background-color: #383942;
  overflow: hidden;
  position: relative;
  .preview {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.s-uploader-label {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.icon-uploader-close {
  width: 18px;
  height: 18px;
  position: absolute;
  //bottom: 5px;
  top: 5px;
  right: 5px;
  background: url(../../assets/images/close.png);
  background-size: contain;
  z-index: 3;
}
</style>



// WEBPACK FOOTER //
// src/components/uploader/index.vue